export default "- [1 USE OF WEBSITE](#1)\n- [2 HYPERLINKS](#2)\n- [3 USE OF COOKIES](#3)\n- [4 VIRUSES](#4)\n- [5 OUR LIABILITY](#5)\n- [6 GENERAL](#6)\n"